import { Component, Inject } from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { SnackbarType } from '../../services/snackbar.service';
import { TranslationRequest } from '../../models/translation/translation-request';

@Component({
    selector: 'app-snackbar-dialog',
    template: `
    <app-action-row>
      <div left1>
        {{ data.message | translation: translationRequest }}
      </div>
      @if(data.dismiss){
      <a
        right1
        tabindex="0"
        [style.color]="linkColor"
        (click)="snackBarRef.dismiss()"
      >
        {{ 'Dismiss' | translation: translationRequest }}
      </a>
      }
    </app-action-row>
  `,
    styles: [``],
    standalone: false
})
export class SnackbarDialogComponent {
  linkColor: string;
  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });

  constructor(
    public snackBarRef: MatSnackBarRef<SnackbarDialogComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {
    this.linkColor = data.type === SnackbarType.Basic ? '' : 'white';
  }
}

export class SnackbarData {
  style: Array<string>;
  message: string;
  dismiss: boolean;
  type: SnackbarType;
}
